import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.83176 7.07124C8.21071 7.47219 7.66953 7.98729 7.23838 8.58663L4.69281 6.75542C5.3524 5.83853 6.17991 5.05075 7.13092 4.43677L8.83176 7.07124Z"
      fill="#ABE3FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66818 9.56658C6.32688 10.3102 6.13581 11.1385 6.13581 12.0157C6.13581 14.9275 8.25401 17.3477 11.0336 17.814L10.5148 20.9066C6.2497 20.191 3 16.4844 3 12.0157C3 10.678 3.29238 9.40424 3.81821 8.25854L6.66818 9.56658Z"
      fill="#0078EF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0155 6.13581C11.3255 6.13581 10.6665 6.25401 10.0555 6.46996L9.0105 3.5134C9.95246 3.18047 10.9646 3 12.0155 3C12.7914 3 13.5465 3.09837 14.2682 3.28412C15.6667 3.64407 16.9322 4.33013 17.9793 5.25427L15.9042 7.60531C15.2192 7.00076 14.3945 6.55463 13.4866 6.32095C13.0181 6.20037 12.5255 6.13581 12.0155 6.13581Z"
      fill="#38D695"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.8951 12.0155C17.8951 10.7335 17.4867 9.55163 16.7925 8.58671L19.3381 6.75549C20.4032 8.23614 21.0309 10.0548 21.0309 12.0155C21.0309 16.7424 17.3942 20.6182 12.765 21.0001L12.5072 17.875C15.5236 17.6261 17.8951 15.097 17.8951 12.0155Z"
      fill="#0035A4"
    />
  </svg>
);
const SvgDonutColored = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgDonutColored;
